(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('change', (event) => {
          fetch(routes.cart_update_url, {
            ...fetchConfig(),
            body: JSON.stringify({ note: event.target.value })
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
